module.exports = __webpack_public_path__ + "img/Proliferation-SCC_GSE144240.7944aaf4.png";